import { themeColors } from "@/styles"
import { FONT } from "@/styles/fonts"
import { makeStyles } from "@/utils"

const useStyles = makeStyles(() => ({
	input: {
		display: "flex",
		alignItems: "center",
		padding: "0 0.75rem",
		color: themeColors.getTextColor(),
		border: `1px solid ${themeColors.colors.system.gray[200]}`,
		borderRadius: "0.25rem",
		gap: "0.5rem",
		width: "100%",
		minHeight: "3.25rem",
		"&:hover": {
			borderColor: themeColors.colors.system.gray[500]
		},
		"&.Mui-disabled": {
			color: themeColors.colors.system.gray[200],
			backgroundColor: themeColors.colors.system.gray[100],
			border: "none"
		},
		"&.Mui-focused": {
			borderColor: themeColors.getPrimaryColor(),
			backgroundColor: themeColors.colors.bot.activeCampaign[100]
		},
		fontSize: FONT.size.small2,
		fontWeight: FONT.fontWeight.medium
	},
	inputError: {
		border: `1px solid ${themeColors.getTextErrorColor()}`,
		borderRadius: "0.25rem",
		gap: "0.5rem",
		padding: "1rem"
	},
	chip: {
		backgroundColor: themeColors.colors.info[100],
		borderRadius: "0.5rem",
		width: "4.5rem",
		height: "1.375rem"
	}
}))

export default useStyles
